import { GymServiceUnitType } from "../models/gym.model";

/** Mirror BE addB2BService / update DAY|MONTH expiry (30-day months). */
export function previewExpirationAt(
  unitType: GymServiceUnitType,
  amount: number,
  from: Date = new Date(),
): Date {
  const today = new Date(from.toDateString());
  if (unitType === "SESSION") return today;
  const days = unitType === "DAY" ? amount : amount * 30;
  const expiry = new Date(today);
  expiry.setDate(expiry.getDate() + days);
  return expiry;
}

export function toDateInputValue(
  value: string | Date | null | undefined,
): string {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1);
  const day = String(d.getDate());
  // Đảm bảo có 2 chữ số bằng slice (không dùng padStart)
  const monthStr = ("0" + m).slice(-2);
  const dayStr = ("0" + day).slice(-2);
  return `${y}-${monthStr}-${dayStr}`;
}
